import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {ThemeContext} from '../../';

const ChatTabs = (props) => {
  const {onTabChanged, tabs, activeTabIndex} = props;

  function renderTabMenuItem(item, index, theme) {
    const key = `_${index}`;
    const {title} = item;
    const isActiveTab = index === activeTabIndex;
    const classes = classNames({
      'tabs-menu__item': true,
      'tabs-menu__item_active': isActiveTab,
    });
    const styles = {
      color: isActiveTab ? theme.primaryColor : theme.secondaryColor,
    };

    return (
      <li
        className={classes}
        key={key}
        onClick={() => onTabChanged(index)}
        role="presentation"
      >
        <span style={styles} className="tabs-menu__link">{title}</span>
      </li>
    );
  }

  return (
    <ThemeContext.Consumer>
      {theme => (
        <div className="tabs-menu">
          <ul className="tabs-menu__wrap">
            {tabs.map((item, index) => renderTabMenuItem(item, index, theme))}
          </ul>
        </div>
      )}
    </ThemeContext.Consumer>
  );
};

ChatTabs.propTypes = {
  onTabChanged: PropTypes.func.isRequired,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeTabIndex: PropTypes.number,
};

ChatTabs.defaultProps = {
  activeTabIndex: 0,
};

export default ChatTabs;
